import { ref, computed } from "vue";
import { useToast } from "vue-toastification"

import store from "../state/store"


export default function useSliders(props, emit, slider) {

    // Get toast interface
    const toast = useToast()

    const sliderStatus = ref("")
    const search = ref("")
    const perPage = ref(10)
    const sortField = ref("updated_at")
    const sortDirection = ref("desc")
    const loading = ref(false)
    const errors = ref({})

    
    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getSliders = (url = null) => {
        store.dispatch("getSliders", {
            url,
            search: search.value,
            status: sliderStatus.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }


    const onSubmit = () => {
        loading.value = true

        if (slider.value.id) {
            store.dispatch('updateSlider', slider.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("اسلاید با موفقیت به روزرسانی شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getSliders")
                        closeModal()
                    }
                })

        } else {
            store
                .dispatch("createSlider", slider.value)
                .then((response) => {
                    loading.value = false
                    if (response.status === 201) {
                        toast.success("اسلاید با موفقیت افزوده شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getSliders")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        }

    }

    const closeModal = () => {
        show.value = false
        errors.value = {}
        const input = document.getElementById("formFile")
        input.value = ""
        slider.value.slider_image = null
        emit("close")
    }


    return {
        show,
        sliderStatus,
        search,
        perPage,
        loading,
        errors,
        getSliders,
        onSubmit,
        closeModal,
    }
}